import { createBrowserRouter, Navigate } from "react-router-dom";
import { PrivateAppRoot } from "./presentation/screens/private/PrivateAppRoot";
import { FormsOverviewScreen } from "./presentation/screens/private/FromsOverview/FormsOverview.screen";
import { FormDetailScreen } from "./presentation/screens/private/FormsDetail/FormDetail.screen";
import React from "react";
import { TemplateOverviewScreen } from "./presentation/screens/private/TemplateOverview/TemplateOverview.Screen";
import { TemplateEditScreen } from "./presentation/screens/private/TemplateEditor/TemplateEdit.Screen";
import { PublicAppRoot } from "./presentation/screens/public/PublicAppRoot";
import { SignedOutScreen } from "./presentation/screens/public/SignedOut/SignedOutScreen";
import { ErrorCasesOverviewScreen } from "./presentation/screens/private/ErrorCasesOverview/ErrorCasesOverview.screen";
import { TemplatePreviewScreen } from "./presentation/screens/private/TemplatePreview/TemplatePreview.Screen";
import { StatisticDownloaderScreen } from "./presentation/screens/private/StatisticsDownloader/StatisticDownloader.Screen";
import {
    ErrorPageScreen,
    PageUnknownErrorErrorScreen
} from "./presentation/screens/public/ErrorPage/ErrorPage.Screen";

export const router = createBrowserRouter([
    {
        path: "/p",
        element: <PublicAppRoot />,
        errorElement: <ErrorPageScreen />,
        hasErrorBoundary: false,
        children: [
            {
                path: "/p/signed-out",
                element: <SignedOutScreen />
            }
        ]
    },
    {
        path: "/",
        element: <PrivateAppRoot />,
        errorElement: <ErrorPageScreen />,
        hasErrorBoundary: true,
        children: [
            {
                path: "/",
                element: <Navigate to="/forms" replace />,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/forms",
                element: <FormsOverviewScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/forms/:formId",
                element: <FormDetailScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/errorcases",
                element: <ErrorCasesOverviewScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/errorcases/:formId",
                element: <FormDetailScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/statistic",
                element: <StatisticDownloaderScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/templates",
                element: <TemplateOverviewScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/templates/:templateId/edit",
                element: <TemplateEditScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            },
            {
                path: "/municipality",
                element: <TemplatePreviewScreen />,
                hasErrorBoundary: true,
                errorElement: <PageUnknownErrorErrorScreen />
            }
        ]
    }
]);
